__webpack_require__.p = "https://portal-builds-4747919q.s3.ap-south-1.amazonaws.com/training-portal/_next/";